<template>
  <div>
    <h3>{{ folder.title }}</h3>
    <v-container fluid>
      <v-layout row v-if="files(folder._id).length > 0" wrap>
        <DocumentChip
          v-for="fl in files(folder._id)"
          :key="fl._id"
          :document="fl"
          @change="$emit('reload')"
          @toggleSelect="$emit('toggleSelect', $event)"
          :selectMode="selectMode"
          :project="project"
          :edit-mode="editMode"
        />
      </v-layout>
      <v-layout row v-else>
        <div class="notice">Aucun document requis</div>
      </v-layout>
      <v-layout row class="justify-end" wrap v-if="editMode">
        <v-flex>
          <v-btn color="red" @click="deleteSection" v-if="withDeleteSection"
            >Supprimer la section</v-btn
          >
        </v-flex>
        <v-flex xs12 lg4 class="mt-2">
          <v-autocomplete
            :items="packs"
            persistent-hint
            label="Ajouter un ensemble de documents requis"
            :value="packName"
            @input="addPack({ value: $event, folder })"
          >
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 lg4 class="mt-2">
          <v-autocomplete
            :items="documentTypesLeft(folder._id)"
            persistent-hint
            label="Ajouter un document requis"
            :value="docName"
            @input="add({ value: $event, folder })"
          >
          </v-autocomplete>

          <div class="d-flex" v-if="showOther">
            <v-text-field
              label="Nom du document"
              v-model="otherDoc"
            ></v-text-field>
            <v-btn
              icon
              style="flex: 0 0 40px !important"
              @click="add({ value: otherDoc, folder })"
              ><v-icon>add</v-icon></v-btn
            >
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import DocumentChip from "../commons/DocumentChip";
import { DOCUMENT_TYPES } from "../../data/DefaultSettings";
import { PREDEFINED_DOCUMENT_TYPES } from "../../../../webapp-commons/data";
import { mapState } from "vuex";
import { fetchHil } from "../../utils";

export default {
  name: "ProjectDocumentsSection",
  components: { DocumentChip },
  props: ["folder", "selectMode", "withDeleteSection", "project", "editMode"],
  data() {
    return { otherDoc: "", showOther: false, docName: "", packName: "" };
  },
  computed: {
    ...mapState("projects", ["documents"]),
    packs() {
      return PREDEFINED_DOCUMENT_TYPES.map(({ pack }) => pack);
    }
  },
  methods: {
    async deleteSection() {
      const leaseId = this.folder.leaseId;
      await fetchHil(`/documents/for/${leaseId}/document/${this.folder._id}`, {
        method: "DELETE"
      });
      this.$emit("reload");
    },
    files(folderId) {
      return this.documents.filter(
        ({ type, parentFolder }) => type === "file" && parentFolder === folderId
      );
    },
    documentTypesLeft(folderId) {
      const fs = this.files(folderId);
      return DOCUMENT_TYPES.filter(
        dt =>
          dt.canAdd !== false &&
          (!dt.folder || dt.folder === this.folder.title) &&
          fs.filter(({ title }) => title === dt.value).length === 0
      );
    },
    addPack({ value, folder }) {
      const items = PREDEFINED_DOCUMENT_TYPES.filter(
        ({ pack }) => pack === value
      )[0].items;
      const documentsLeft = this.documentTypesLeft(folder._id).map(
        ({ value }) => value
      );
      items.forEach(it => {
        if (documentsLeft.indexOf(it) !== -1) {
          this.add({ value: it, folder });
        }
      });
      this.packName = "";
    },
    add({ value, folder }) {
      this.otherDoc = "";
      if (value === "autres") {
        this.showOther = true;
      } else {
        this.showOther = false;
        this.docName = "";
        this.$emit("add", { value, folder });
      }
    }
  }
};
</script>

<style scoped></style>
